import {Component, ElementRef, Inject, OnInit} from '@angular/core';
import {Meta, MetaDefinition} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {AadB2CHelper} from '../../helpers/AadB2CHelper';
import {AADB2C_HELPER} from '../../providers/aadb2c.helper.provider';
import {LABELS_SERVICE} from '../../providers/service.providers';
import {LabelsService} from '../../services/labels.service';
import {ScrollService} from '../../services/scroll.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    apiEndpoint: string;
    emApplicationtoken: string;
    assetsEndpoint: string;
    tenantID: string;
    clientID: string;
    redirectUri: string;
    eventtypeid: string;
    isAuthenticationEnabled: boolean;
    startPoint: boolean;

    constructor(
        @Inject(LABELS_SERVICE) public labelsService: LabelsService,
        private metaService: Meta,
        private elementRef: ElementRef,
        private router: Router,
        private scrollService: ScrollService,
        @Inject(AADB2C_HELPER) private aadB2CHelper: AadB2CHelper) {
        environment.apiEndpoint = this.elementRef.nativeElement.getAttribute('apiEndpoint') || environment.apiEndpoint;
        environment.emApplicationtoken = this.elementRef.nativeElement.getAttribute('emApplicationtoken') || environment.emApplicationtoken;
        environment.usePreview = this.isPreview();
        environment.internalEventPage = this.elementRef.nativeElement.getAttribute('redirectUri') || environment.internalEventPage;
        if (environment.usePreview) {
          this.router.navigate(['eventsPreview'], { skipLocationChange: true });
        }
        environment.eventtypeid = this.elementRef.nativeElement.getAttribute('eventtypeid') || environment.eventtypeid;
        environment.beServer = this.elementRef.nativeElement.getAttribute('beserver') || environment.beServer;
        this.assetsEndpoint = this.elementRef.nativeElement.getAttribute('assetsEndpoint');
        if (this.assetsEndpoint) {
          environment.imagesEndpoint = this.elementRef.nativeElement.getAttribute('assetsEndpoint') + 'images/';
          environment.localizationEndpoint = this.elementRef.nativeElement.getAttribute('assetsEndpoint') + 'Localization/';
        }
        if (this.elementRef.nativeElement.getAttribute('isAuthenticationEnabled')) {
          environment.isAuthenticationEnabled = (/true/i).test(this.elementRef.nativeElement.getAttribute('isAuthenticationEnabled'));
        }
        if (environment.isAuthenticationEnabled) {
          environment.aadB2CConfig.clientID = this.elementRef.nativeElement.getAttribute('clientID') || environment.aadB2CConfig.clientID;
          this.tenantID = this.elementRef.nativeElement.getAttribute('tenantID');
          if (this.tenantID) {
            environment.aadB2CConfig.tenant = this.tenantID + '.onmicrosoft.com';
            environment.aadB2CConfig.authorityHost = this.tenantID + '.b2clogin.com';
          }
          environment.aadB2CConfig.redirectUri = this.elementRef.nativeElement.getAttribute('redirectUri') || environment.aadB2CConfig.redirectUri;
          this.aadB2CHelper.setClientApplication();
        }

        scrollService.init(elementRef, [
        '/events/overview',
        '/event?',
        '/event/sessions?',
        '/event/session-tracks?',
        '/event/speakers?',
        '/event/pass-information?',
        '/event/registration?'
      ]);
    }

    ngOnInit() {
        this.labelsService.getLabelsModel().subscribe((labelsModel) => {
            // force get the labels
        });
        this.addBuildVersionToMetaTags();
    }

    private addBuildVersionToMetaTags() {
        let metaBuildVersion = '0.0.0';
        if (environment && environment.buildVersion) {
            metaBuildVersion = environment.buildVersion;
        }

        const metaDefinition: MetaDefinition = {
            name: 'build-version',
            content: metaBuildVersion
        };

        this.metaService.addTag(metaDefinition);
    }

  isPreview() {
      if (!this.startPoint && this.elementRef.nativeElement.getAttribute('isPreview')) {
        this.startPoint = (/true/i).test(this.elementRef.nativeElement.getAttribute('isPreview'));
      }
      return this.startPoint;
    }
}
